module.exports = __webpack_public_path__ + "img/mega_3.b73dc122.png";